<div class="padding">
	<b>Orders</b>
	<div class="flex column gap margin-top-small scrollable">
		@for (order of orders; track $index) {
			<a class="padding-small border hover margin-right-small" [routerLink]="['/company/order-view/' + order.id + '/order-detail-info']" (click)="close()">
				<div class="flex column">
					<span class="margin-bottom-small">
						Order
						<b>#{{ order.id }}</b>
					</span>

					<div class="flex between end">
						<div class="grey small">
							{{ order.creationDate | date: 'dd/MM/yyyy HH:mm' }}
						</div>
						<div class="center flex">
							 
							@if (order.status.id == orderStatus.Draft) {
								<span class="radius bg-light-grey primary-dark padding-right-smallest padding-left-smallest">Draft</span>
							} @else if (order.status.id == orderStatus.Submitted) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Submitted</span>
							} @else if (order.status.id == orderStatus.ShootCompleted) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">Shoot completed</span>
							} @else if (order.status.id == orderStatus.InProgress) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">In Progress</span>
							} @else if (order.status.id == orderStatus.Rejected) {
								<span class="radius bg-red white padding-right-smallest padding-left-smallest">Rejected</span>
							} @else if (order.status.id == orderStatus.Approved) {
								<span class="radius bg-green white padding-right-smallest padding-left-smallest">Approved</span>
							} @else if (order.status.id == orderStatus.ReadyForPickup) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Ready for Pickup</span>
							}
						</div>
					</div>
				</div>
			</a>
		}
	</div>

	<div class="flex column end margin-top">
		<button class="stroked" (click)="close()">
			<i class="fa-solid fa-undo"></i>
			Close
		</button>
	</div>
</div>
